/**
 * Extracts actual zone names from unique keys used in the IPDB tree selector.
 *
 * @param zones - Array of zone keys from the tree selector
 * @param orgLayerKeyToName - Map of org_layer_* keys to their actual layer names
 * @returns Array of actual zone names
 */
export function extractZoneNames(
  zones: string[],
  orgLayerKeyToName: Map<string, string>
): string[] {
  return zones.map((zone) => {
    if (zone.startsWith("org_layer_")) {
      // Use the lookup map for guaranteed O(1) resolution
      return orgLayerKeyToName.get(zone);
    } else if (zone.startsWith("org_cutoff_")) {
      return zone.replace("org_cutoff_", "");
    }
    return zone;
  });
}
